import { z } from 'zod';
import { DEPARTMENT_CONSTRAINTS } from './constraints.js';
export const departmentCreateFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${DEPARTMENT_CONSTRAINTS.name.label} is required.`)
        .max(DEPARTMENT_CONSTRAINTS.name.maxLength),
});
//# sourceMappingURL=create-form.js.map